<div *ngIf="title" class="title" [ngClass]="{ 'title--has-controls': hasControls }">
  <div class="title__content">
    <h1 *ngIf="region === contentBlockRegion.highlighted" [ngClass]="{ 't--center': isCentered }">{{ title }}</h1>
    <h2 *ngIf="region === contentBlockRegion.primary && isFirst" [ngClass]="{ 't--center': isCentered }">{{ title }}</h2>
    <h3
      *ngIf="
        region === contentBlockRegion.secondary ||
        (region === contentBlockRegion.primary && !isFirst) ||
        region === contentBlockRegion.partnerPrimary
      "
    >
      {{ title }}
    </h3>
    <h6 *ngIf="subtitle">{{ subtitle }}</h6>
  </div>
  <div #controls class="title__controls">
    <ng-content></ng-content>
  </div>
</div>
